import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import fr from 'vuetify/src/locale/fr.ts';


// Helpers
// import colors from 'vuetify/es5/util/colors';
import mySvgIcon from '../components/MySvgIcon.vue';
// https://theme-generator.vuetifyjs.com/
// https://vuetifyjs.com/en/styles/colors/
// to be able to make custom theme work i nedd to read and use this
// https://vuetifyjs.com/en/getting-started/releases-and-migrations/
const myVuetifyOptions = {
  iconfont: 'mdiSvg',
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#2196F3',
        secondary: '#009688',
        accent: '#40C4FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      },
      dark: {
        primary: '#f4b803',
        secondary: '#009688',
        accent: '#40C4FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      },
    },
  },
  lang: {
    locales: { fr },
    current: 'fr',
  },
  icons: {
    sticker: {
      component: mySvgIcon,
      props: {
        iconId: 'sticker',
        width: 32,
        height: 32,
      },
    },
  },
};

Vue.use(Vuetify);
export default new Vuetify(myVuetifyOptions);
